import { getCategories } from "../../../../api/categories";
import { getCatalogs } from "../../../../api/catalogs";
export const categoryProductCount = (row) =>
  Array.isArray(row.Products)
    ? new Set(row.Products.map((product) => product.productId)).size
    : Number.isFinite(Number(row.productQuantity)) &&
        row.productQuantity != null
      ? Number(row.productQuantity)
      : null;
export const categoryCatalogNames = (row) =>
  row.catalogLinks === null ? "No disponible" : row.catalogLinks?.map((catalog) => catalog.name).join(" · ") || "—";
export const getCategoryList = async () => {
  const [categories, catalogs] = await Promise.all([
    getCategories(),
    getCatalogs(),
  ]);
  const categoryRows =
    categories?.error && categories.message === "No categories found"
      ? []
      : categories?.data;
  if (
    (categories?.error !== false && !(categories?.error === true && categories.message === "No categories found")) ||
    !Array.isArray(categoryRows) ||
    catalogs?.error !== false ||
    !Array.isArray(catalogs.data) ||
    catalogs.data.some((row) => !Array.isArray(row.Products))
  )
    return { error: true };
  const options = catalogs.data.map((row) => ({
    value: row.catalogId,
    label: row.name,
  }));
  return {
    error: false,
    data: categoryRows.map((row) => {
      if (!Array.isArray(row.Products))
        return { ...row, catalogLinks: null, catalogOptions: options };
      const productIds = new Set(
        row.Products.map((product) => product.productId),
      );
      return {
        ...row,
        catalogOptions: options,
        catalogLinks: catalogs.data
          .filter((catalog) =>
            catalog.Products.some((product) =>
              productIds.has(product.productId),
            ),
          )
          .map((catalog) => ({
            catalogId: catalog.catalogId,
            name: catalog.name,
          })),
      };
    }),
  };
};
